import { NOTIFICATIONS_BASE_ROUTE } from "@/constants/notifications";

// The notification wizard no longer chains task-to-task: completing, skipping,
// or going back from any landing page returns to the /notifications list
// (which is refreshed by each page's own awaitRefetchQueries / network-only).
// Call sites may still pass navigation state; the wizard no longer reads it.
const useNotificationsNavigation = (options = {}) => {
	void options;
	return {
		next: NOTIFICATIONS_BASE_ROUTE,
		previous: NOTIFICATIONS_BASE_ROUTE,
	};
};

export default useNotificationsNavigation;
